module.exports = __webpack_public_path__ + "static/media/image11.8d265078.jpg";